module.exports = __webpack_public_path__ + "static/media/Interview.462d98ed.svg";